module.exports = __webpack_public_path__ + "static/media/pink_green1.e7e14305.jpg";